var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        visible: _vm.visible,
        "destroy-on-close": true,
        "append-to-body": "",
        "custom-class": "myFormDrawer quotationApprovalDrawer",
        size: "88%",
        title: _vm.title,
      },
      on: { close: _vm.handleDrawerClose },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "quotation-approval-body",
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "需审核报价单信息", name: "audit" },
              }),
              _vm.showProjectDetailTab
                ? _c("el-tab-pane", {
                    attrs: { label: "项目详情", name: "projectDetail" },
                  })
                : _vm._e(),
              _c("el-tab-pane", {
                attrs: {
                  label:
                    "同类型历史订单" +
                    (_vm.sameOrderTotal !== null
                      ? "（" + _vm.sameOrderTotal + "）"
                      : ""),
                  name: "sameOrder",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label:
                    "其他类型历史订单" +
                    (_vm.otherOrderTotal !== null
                      ? "（" + _vm.otherOrderTotal + "）"
                      : ""),
                  name: "otherOrder",
                },
              }),
              _vm.isSecondApproval
                ? _c("el-tab-pane", {
                    attrs: {
                      label: "标准卡折扣",
                      name: "standardCardDiscount",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab === "audit",
                  expression: "activeTab === 'audit'",
                },
              ],
              ref: "auditForm",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "130px",
              },
            },
            [
              _c(
                "div",
                { staticClass: "section-block" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("报价单信息"),
                  ]),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "客户名称" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.formData.customer_name,
                                  disabled: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "发起人" } },
                            [
                              _c("el-input", {
                                attrs: { value: _vm.inputName, disabled: "" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "业务类型",
                                prop: "items.quotation.business_type",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.changeBusinessType },
                                  model: {
                                    value:
                                      _vm.formData.items.quotation
                                        .business_type,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items.quotation,
                                        "business_type",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.quotation.business_type",
                                  },
                                },
                                _vm._l(_vm.businessTypeList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "卡类型",
                                prop: "items.quotation.card_type",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择",
                                    disabled:
                                      !_vm.formData.items.quotation
                                        .business_type,
                                  },
                                  model: {
                                    value:
                                      _vm.formData.items.quotation.card_type,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items.quotation,
                                        "card_type",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.quotation.card_type",
                                  },
                                },
                                _vm._l(
                                  _vm.quotationCardTypeList,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "采购金额",
                                prop: "items.quotation.money",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                on: {
                                  input: function ($event) {
                                    return _vm.handleAmountInput("money")
                                  },
                                  change: _vm.calcBudget,
                                },
                                model: {
                                  value: _vm.formData.items.quotation.money,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.quotation,
                                      "money",
                                      $$v
                                    )
                                  },
                                  expression: "formData.items.quotation.money",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "人数",
                                prop: "items.quotation.number",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                on: {
                                  input: _vm.handleNumberInput,
                                  change: _vm.calcBudget,
                                },
                                model: {
                                  value: _vm.formData.items.quotation.number,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.quotation,
                                      "number",
                                      $$v
                                    )
                                  },
                                  expression: "formData.items.quotation.number",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "单人预算",
                                prop: "items.quotation.budget",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                on: {
                                  input: function ($event) {
                                    return _vm.handleAmountInput("budget")
                                  },
                                  change: _vm.calcMoney,
                                },
                                model: {
                                  value: _vm.formData.items.quotation.budget,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.quotation,
                                      "budget",
                                      $$v
                                    )
                                  },
                                  expression: "formData.items.quotation.budget",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "items.quotation.cost" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        color: _vm.costLabelRed ? "red" : "",
                                      },
                                    },
                                    [_vm._v("服务费成本")]
                                  ),
                                ]
                              ),
                              _c(
                                "el-input",
                                {
                                  attrs: { placeholder: "请输入" },
                                  on: {
                                    input: function ($event) {
                                      return _vm.handleAmountInput("cost", 2, 8)
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.items.quotation.cost,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items.quotation,
                                        "cost",
                                        $$v
                                      )
                                    },
                                    expression: "formData.items.quotation.cost",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("元"),
                                  ]),
                                ],
                                2
                              ),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v(
                                  " 销售业绩以佣金基数=售卡金额-服务成本 "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "items.quotation.final_quotation",
                              },
                            },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        color: _vm.discountLabelRed
                                          ? "red"
                                          : "",
                                      },
                                    },
                                    [_vm._v("折扣")]
                                  ),
                                ]
                              ),
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                on: {
                                  input: function ($event) {
                                    return _vm.handleAmountInput(
                                      "final_quotation",
                                      3
                                    )
                                  },
                                  change: _vm.loadQuotationCommissionInfo,
                                },
                                model: {
                                  value:
                                    _vm.formData.items.quotation
                                      .final_quotation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.quotation,
                                      "final_quotation",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.items.quotation.final_quotation",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "总点数" } },
                            [
                              _c("el-input", {
                                attrs: { value: _vm.totalPoints, disabled: "" },
                              }),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v("售卡金额/折扣"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "结算方式",
                                prop: "items.quotation.payment_method",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value:
                                      _vm.formData.items.quotation
                                        .payment_method,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items.quotation,
                                        "payment_method",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.quotation.payment_method",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: "1" } }, [
                                    _vm._v("按售卡结算"),
                                  ]),
                                  _c("el-radio", { attrs: { label: "2" } }, [
                                    _vm._v("按消费结算"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "items.quotation.accounting_method",
                              },
                            },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        color: _vm.accountingLabelRed
                                          ? "red"
                                          : "",
                                      },
                                    },
                                    [_vm._v("佣金核算方式")]
                                  ),
                                ]
                              ),
                              _c(
                                "el-radio-group",
                                {
                                  on: {
                                    change: _vm.handleAccountingMethodChange,
                                  },
                                  model: {
                                    value:
                                      _vm.formData.items.quotation
                                        .accounting_method,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items.quotation,
                                        "accounting_method",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.quotation.accounting_method",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: "1" } }, [
                                    _vm._v("系统核算"),
                                  ]),
                                  _c("el-radio", { attrs: { label: "2" } }, [
                                    _vm._v("人工核算"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _vm.showCustomerNature
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          style: {
                                            color: _vm.customerNatureLabelRed
                                              ? "red"
                                              : "",
                                          },
                                        },
                                        [_vm._v("客户类型")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.formData.customer_nature,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "customer_nature",
                                            $$v
                                          )
                                        },
                                        expression: "formData.customer_nature",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "-1" } },
                                        [_vm._v("未认定")]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "1" } },
                                        [
                                          _vm._v(
                                            "一类客户 [政府机构/事业单位/国有控股、国有独资企业]"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "3" } },
                                        [
                                          _vm._v(
                                            "二类客户[国有参股企业(实缴资本＞1000万)]"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "2" } },
                                        [
                                          _vm._v(
                                            "三类客户[除一类、二类之外的企业]"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "报价单时效",
                                prop: "items.quotation.time_limit",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  "value-format": "yyyy-MM-dd",
                                  placeholder: "请选择",
                                  disabled: _vm.isFirstApproval,
                                },
                                model: {
                                  value:
                                    _vm.formData.items.quotation.time_limit,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.quotation,
                                      "time_limit",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.items.quotation.time_limit",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "items.quotation.description" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        color: _vm.descriptionLabelRed
                                          ? "red"
                                          : "",
                                      },
                                    },
                                    [_vm._v("功能菜单描述")]
                                  ),
                                ]
                              ),
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value:
                                      _vm.formData.items.quotation.description,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items.quotation,
                                        "description",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.quotation.description",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: "1" } }, [
                                    _vm._v("通用卡规则"),
                                  ]),
                                  _c("el-radio", { attrs: { label: "2" } }, [
                                    _vm._v("个性化卡规则"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "items.quotation.order_rules" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        color: _vm.orderRulesLabelRed
                                          ? "red"
                                          : "",
                                      },
                                    },
                                    [_vm._v("备注")]
                                  ),
                                ]
                              ),
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 4,
                                  placeholder: "请输入需要审批的事项",
                                  maxlength: 2000,
                                  "show-word-limit": "",
                                },
                                model: {
                                  value:
                                    _vm.formData.items.quotation.order_rules,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData.items.quotation,
                                      "order_rules",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.items.quotation.order_rules",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "初审备注" } },
                            [
                              _vm.approverType === "1"
                                ? _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      rows: 4,
                                      maxlength: 2000,
                                      "show-word-limit": "",
                                      placeholder: "请输入初审备注",
                                    },
                                    model: {
                                      value:
                                        _vm.formData.items.quotation
                                          .manager_remarks,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData.items.quotation,
                                          "manager_remarks",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formData.items.quotation.manager_remarks",
                                    },
                                  })
                                : _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      readonly: "",
                                      value:
                                        _vm.formData.items.quotation
                                          .manager_remarks,
                                      rows: 4,
                                      placeholder: "暂无初审备注",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.approverType === "2" || _vm.vpRemarksShow
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "复审备注" } },
                                [
                                  _vm.approverType === "2"
                                    ? _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          rows: 4,
                                          maxlength: 2000,
                                          "show-word-limit": "",
                                          placeholder: "请输入复审备注",
                                        },
                                        model: {
                                          value:
                                            _vm.formData.items.quotation
                                              .vp_remarks,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData.items.quotation,
                                              "vp_remarks",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.items.quotation.vp_remarks",
                                        },
                                      })
                                    : _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          readonly: "",
                                          value:
                                            _vm.formData.items.quotation
                                              .vp_remarks,
                                          rows: 4,
                                          placeholder: "暂无复审备注",
                                        },
                                      }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section-block" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("佣金信息"),
                  ]),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "items.quotation.commission",
                                required: _vm.isSecondApproval,
                              },
                            },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        color: _vm.commissionLabelRed
                                          ? "red"
                                          : "",
                                      },
                                    },
                                    [_vm._v("佣金比例")]
                                  ),
                                ]
                              ),
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    disabled: _vm.isFirstApproval,
                                    placeholder: "请输入",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.handleAmountInput("commission")
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.formData.items.quotation.commission,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items.quotation,
                                        "commission",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.quotation.commission",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "items.quotation.performance",
                                required: _vm.isSecondApproval,
                              },
                            },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c(
                                    "span",
                                    {
                                      style: {
                                        color: _vm.commissionLabelRed
                                          ? "red"
                                          : "",
                                      },
                                    },
                                    [_vm._v("计入业绩")]
                                  ),
                                ]
                              ),
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    disabled: _vm.isFirstApproval,
                                    placeholder: "请输入",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.handleAmountInput(
                                        "performance"
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.formData.items.quotation.performance,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.items.quotation,
                                        "performance",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.items.quotation.performance",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("%"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab === "audit",
                  expression: "activeTab === 'audit'",
                },
              ],
              staticClass: "drawer-footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: {
                    click: function ($event) {
                      return _vm.handleAudit(1)
                    },
                  },
                },
                [_vm._v("通 过")]
              ),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.submitLoading },
                  on: {
                    click: function ($event) {
                      return _vm.handleAudit(2)
                    },
                  },
                },
                [_vm._v("驳 回")]
              ),
            ],
            1
          ),
          _vm.activeTab === "sameOrder" || _vm.activeTab === "otherOrder"
            ? [
                _c("sameTypeHistoryOrder", {
                  attrs: {
                    "table-data": _vm.historyTableData,
                    pages: _vm.historyPages,
                  },
                  on: {
                    emitToTend: _vm.emitToTend,
                    sortChange: _vm.historySortChange,
                    onChange: _vm.historyPageChange,
                  },
                }),
              ]
            : _vm._e(),
          _vm.activeTab === "standardCardDiscount"
            ? [
                _c("standardCardDiscount", {
                  key:
                    _vm.formData.items.quotation.business_type +
                    "-" +
                    _vm.formData.items.quotation.card_type,
                  attrs: {
                    card_bin_group_id:
                      _vm.formData.items.quotation.business_type,
                    card_bin_id: _vm.formData.items.quotation.card_type,
                  },
                }),
              ]
            : _vm._e(),
          _vm.showProjectDetailTab && _vm.projectDetailLoaded
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab === "projectDetail",
                      expression: "activeTab === 'projectDetail'",
                    },
                  ],
                  staticClass: "project-detail-pane",
                },
                [
                  _c("applyForm", {
                    attrs: {
                      type: "view",
                      id: _vm.id,
                      projectType: _vm.projectType,
                      "disable-edit": true,
                      "force-log-tab": true,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-drawer",
            {
              attrs: {
                title: "订单数据分析",
                visible: _vm.drawerTrend,
                size: "87%",
                "custom-class": "myDrawer",
                "append-to-body": "",
                "destroy-on-close": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.drawerTrend = $event
                },
              },
            },
            [
              _c("orderConsumeptionTrend", {
                attrs: { trendParams: _vm.trendParams },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }